import { Injectable } from '@angular/core';

export interface ProvinceOption {
    iso: string;
    name: string;
}

@Injectable()
export class ProvincesService {
    private readonly provinces: ProvinceOption[] = [
        { iso: '01', name: 'Álava' },
        { iso: '02', name: 'Albacete' },
        { iso: '03', name: 'Alicante' },
        { iso: '04', name: 'Almería' },
        { iso: '05', name: 'Ávila' },
        { iso: '06', name: 'Badajoz' },
        { iso: '07', name: 'Baleares' },
        { iso: '08', name: 'Barcelona' },
        { iso: '09', name: 'Burgos' },
        { iso: '10', name: 'Cáceres' },
        { iso: '11', name: 'Cádiz' },
        { iso: '12', name: 'Castellón' },
        { iso: '13', name: 'Ciudad Real' },
        { iso: '14', name: 'Córdoba' },
        { iso: '15', name: 'A Coruña' },
        { iso: '16', name: 'Cuenca' },
        { iso: '17', name: 'Girona' },
        { iso: '18', name: 'Granada' },
        { iso: '19', name: 'Guadalajara' },
        { iso: '20', name: 'Guipúzcoa' },
        { iso: '21', name: 'Huelva' },
        { iso: '22', name: 'Huesca' },
        { iso: '23', name: 'jaen' },
        { iso: '24', name: 'León' },
        { iso: '25', name: 'Lleida' },
        { iso: '26', name: 'La Rioja' },
        { iso: '27', name: 'Lugo' },
        { iso: '28', name: 'Madrid' },
        { iso: '29', name: 'Málaga' },
        { iso: '30', name: 'Murcia' },
        { iso: '31', name: 'Navarra' },
        { iso: '32', name: 'Ourense' },
        { iso: '33', name: 'Asturias' },
        { iso: '34', name: 'Palencia' },
        { iso: '35', name: 'Las Palmas' },
        { iso: '36', name: 'Pontevedra' },
        { iso: '37', name: 'Salamanca' },
        { iso: '38', name: 'Santa Cruz de Tenerife' },
        { iso: '39', name: 'Cantabria' },
        { iso: '40', name: 'Segovia' },
        { iso: '41', name: 'Sevilla' },
        { iso: '42', name: 'Soria' },
        { iso: '43', name: 'Tarragona' },
        { iso: '44', name: 'Teruel' },
        { iso: '45', name: 'Toledo' },
        { iso: '46', name: 'Valencia' },
        { iso: '47', name: 'Valladolid' },
        { iso: '48', name: 'Vizcaya' },
        { iso: '49', name: 'Zamora' },
        { iso: '50', name: 'Zaragoza' },
        { iso: '51', name: 'Ceuta' },
        { iso: '52', name: 'Melilla' },
    ];

    getProvinces(): ProvinceOption[] {
        return this.provinces;
    }
}
